import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const DeleteFailureAlert = ({
  message = "Failed to delete the record. Please try again.",
  onClose,
}) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
         padding: 2,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 320,
          borderRadius: 4,
          textAlign: "center",
          p: 3,
        }}
      >
        <CardContent>
          <DeleteOutlineIcon
            sx={{
              fontSize: 70,
              color: "error.main",
              mb: 2,
            }}
          />

          <Typography variant="h6" fontWeight="bold">
            Delete Failed
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3}>
            {message}
          </Typography>

          <Button
            variant="contained"
            color="error"
            fullWidth
            onClick={onClose}
            sx={{ borderRadius: 3 }}
          >
            OK
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DeleteFailureAlert;